/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_steps/GreetingCardStep.js
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Wed Apr 16 2025
 */

import React, { useContext} from 'react';
import {FormContext} from "@proxy/_contexts";
import {
  CardImage,
  Footer
} from "../_sections";

export default function GreetingCardStep({
  togglePreview
}) {

  const { settings, currentStep }  = useContext(FormContext);

  return (
    <div className={currentStep === "greeting_card" ? "gc__step gc__step_active" : "gc__step gc__step_inactive"}>
      <CardImage />
      {settings?.global?.appearance?.form_theme === "classic" && (
        <Footer togglePreview={togglePreview} />
      )}
    </div>
  );
};
